import InfoIcon from '@mui/icons-material/Info';
import { Box, IconButton, Link, List, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';
import { SetStateAction, useState } from 'react';

import DescriptionModal from '..';
import { AdvertisedCompany, InstanceInfo } from '../../../../Types/AuthServer';
import AvatarImageWrapper from '../../../Avatars/AvatarImageWrapper';
import { UploadType } from '../../../Image/UploadType';

interface CompanyTabProps {
    companies: AdvertisedCompany[] | undefined;
    domain: string | undefined;
    instanceInfo: InstanceInfo | undefined;
}

export default function CompanyTab({ companies, domain, instanceInfo }: Readonly<CompanyTabProps>) {
    const [modalData, setModalData] = useState({ description: '', id: '', name: '' });
    const [open, setOpen] = useState(false);
    const handleOpen = (e: SetStateAction<{ description: string; id: string; name: string }>) => {
        setOpen(true);
        setModalData(e);
    };
    const handleClose = () => {
        setOpen(false);
    };

    return companies && companies.length > 0 ? (
        <Box>
            <List disablePadding sx={{ bgcolor: 'background.paper', width: '100%' }}>
                {companies.map((item) => (
                    <ListItem
                        disablePadding
                        key={item.id}
                        secondaryAction={
                            <IconButton edge="end" onClick={() => handleOpen(item)}>
                                <InfoIcon color="primary" />
                            </IconButton>
                        }
                    >
                        <ListItemAvatar>
                            <AvatarImageWrapper
                                imagePath={item.image}
                                imageType={UploadType.Company}
                                isLoading={false}
                            />
                        </ListItemAvatar>
                        <ListItemText
                            primary={item.name}
                            secondary={
                                item.links.company_page ? (
                                    <Link href={item.links.company_page} rel="noopener noreferrer" target="_blank">
                                        {item.links.company_page}
                                    </Link>
                                ) : null
                            }
                        />
                    </ListItem>
                ))}
            </List>
            <DescriptionModal
                excludedKeys={['id', 'users', 'dashboard', 'user_invite', 'user', 'advertise']}
                hideActiveTime
                hideTC
                instanceDescription={companies.find((company) => company.id === modalData.id)}
                noMap
                onClose={handleClose}
                open={open}
            />
        </Box>
    ) : (
        <Box>
            <Typography>No advertised companies</Typography>
        </Box>
    );
}
